export default "__VITE_ASSET__85457116__"